/* Milano buy box */
(function () {
  function init(root) {
    if (!root || root.dataset.mlbReady === '1') return;
    var dataEl = root.querySelector('[data-mlb-data]');
    if (!dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = DATA.variants || [];
    var S = DATA.strings || {};

    var idInput = root.querySelector('[data-mlb-id]');
    var atcBtn = root.querySelector('[data-mlb-atc]');
    var atcText = root.querySelector('[data-mlb-atc-text]');
    var atcPrice = root.querySelector('[data-mlb-atc-price]');
    var priceNow = root.querySelector('[data-mlb-price]');
    var priceWas = root.querySelector('[data-mlb-compare]');
    var priceSave = root.querySelector('[data-mlb-save]');
    var stockWrap = root.querySelector('.mlb-ships');
    var stockText = root.querySelector('[data-mlb-stock-text]');
    var slides = [].slice.call(root.querySelectorAll('[data-mlb-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-mlb-thumb]'));

    /* Productos sin opciones (una sola version, "Default Title") no pintan
       selector, asi que no hay ningun radio que leer. Sin esta bandera la
       busqueda de variante no encuentra nada y el boton se queda en
       "Agotado" aunque haya stock. */
    var hayOpciones = root.querySelectorAll('[data-mlb-option]').length > 0;

    /* ---------------------------------------------------------------
       Agrupar las fotos por color.
       El color de cada foto se saca de su texto alternativo: si el alt
       contiene el nombre de un valor de opcion ("marron chocolate"),
       esa foto pertenece a ese color. Las que no mencionan ninguno son
       comunes (interior, detalle del material) y salen siempre.
       Asi no hay que tocar el Liquid: basta con escribir bien los alt
       de las fotos del producto.
    --------------------------------------------------------------- */
    var valoresPorPosicion = {};
    variants.forEach(function (v) {
      (v.options || []).forEach(function (val, i) {
        var p = i + 1;
        if (!valoresPorPosicion[p]) valoresPorPosicion[p] = [];
        if (valoresPorPosicion[p].indexOf(val) < 0) valoresPorPosicion[p].push(val);
      });
    });

    var colorDeMedia = {};
    var posColor = 0;

    if (hayOpciones) {
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        var alt = (img && img.alt ? img.alt : '').toLowerCase();
        if (!alt) return;
        var mejor = '', mejorPos = 0;
        Object.keys(valoresPorPosicion).forEach(function (p) {
          valoresPorPosicion[p].forEach(function (val) {
            if (!val) return;
            // el valor mas largo gana, por si un nombre contiene a otro
            if (alt.indexOf(val.toLowerCase()) >= 0 && val.length > mejor.length) {
              mejor = val; mejorPos = parseInt(p, 10);
            }
          });
        });
        if (mejor) {
          colorDeMedia[s.dataset.mediaId] = mejor;
          posColor = mejorPos;
        }
      });
    }

    var hayGrupos = posColor > 0;

    // las fotos comunes se llevan al final, para que las del color elegido vayan primero
    if (hayGrupos) {
      var escena = slides.length ? slides[0].parentNode : null;
      var tira = thumbs.length ? thumbs[0].parentNode : null;
      slides.forEach(function (s) {
        if (!colorDeMedia[s.dataset.mediaId] && escena) escena.appendChild(s);
      });
      thumbs.forEach(function (t) {
        if (!colorDeMedia[t.dataset.mediaId] && tira) tira.appendChild(t);
      });
      slides = [].slice.call(root.querySelectorAll('[data-mlb-slide]'));
      thumbs = [].slice.call(root.querySelectorAll('[data-mlb-thumb]'));
    }

    function esVisible(mediaId, color) {
      var c = colorDeMedia[mediaId];
      return !c || c === color;
    }

    function filtrarPorColor(color) {
      var primero = null;
      slides.forEach(function (s) {
        var ok = esVisible(s.dataset.mediaId, color);
        s.hidden = !ok;
        if (!ok) {
          s.classList.remove('is-active');
          var vid = s.querySelector('video');
          if (vid && !vid.paused) vid.pause();
        }
        if (ok && !primero) primero = s;
      });
      thumbs.forEach(function (t) {
        t.hidden = !esVisible(t.dataset.mediaId, color);
      });
      return primero;
    }

    function activar(slide) {
      if (!slide) return;
      slides.forEach(function (s) {
        var on = s === slide;
        s.classList.toggle('is-active', on);
        if (!on) {
          var vid = s.querySelector('video');
          if (vid && !vid.paused) vid.pause();
        }
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.mediaId) === String(slide.dataset.mediaId));
      });
      var img = slide.querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }

    function slidePorMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(mediaId)) return slides[i];
      }
      return null;
    }

    function thumbPorMedia(mediaId) {
      for (var i = 0; i < thumbs.length; i++) {
        if (String(thumbs[i].dataset.mediaId) === String(mediaId)) return thumbs[i];
      }
      return null;
    }

    /* La foto principal del color elegido se pone la primera de la tira.
       Shopify guarda las fotos en el orden en que se subieron, asi que la
       de estudio de un color puede quedar la cuarta de su grupo; aqui se
       adelanta para que sea siempre la que abre. */
    function alFrente(mediaId) {
      var s = slidePorMedia(mediaId);
      if (s && s.parentNode && s.parentNode.firstChild !== s) {
        s.parentNode.insertBefore(s, s.parentNode.firstChild);
      }
      var t = thumbPorMedia(mediaId);
      if (t && t.parentNode && t.parentNode.firstChild !== t) {
        t.parentNode.insertBefore(t, t.parentNode.firstChild);
        if (t.parentNode.scrollLeft) t.parentNode.scrollLeft = 0;
      }
    }

    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-mlb-option]').forEach(function (input) {
        if (input.checked) out[parseInt(input.dataset.mlbOption, 10) - 1] = input.value;
      });
      return out;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var vo = variants[i].options || [];
        var ok = true;
        for (var j = 0; j < vo.length; j++) { if (vo[j] !== opts[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }

    function paintSelection() {
      root.querySelectorAll('.mlb-swatch').forEach(function (label) {
        var input = label.querySelector('input');
        label.classList.toggle('is-selected', !!(input && input.checked));
      });
      root.querySelectorAll('[data-mlb-optlabel]').forEach(function (span) {
        var checked = root.querySelector('[data-mlb-option="' + span.dataset.mlbOptlabel + '"]:checked');
        if (checked) span.textContent = checked.value;
      });
    }

    function update() {
      paintSelection();
      var opts = selectedOptions();
      var v = hayOpciones ? findVariant(opts) : (variants[0] || null);

      if (!v) {
        if (atcBtn) atcBtn.disabled = true;
        if (atcText) atcText.textContent = S.soldOut || 'Agotado';
        if (atcPrice) atcPrice.textContent = '';
        return;
      }

      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = v.price;
      if (priceWas) { priceWas.textContent = v.compare || ''; priceWas.hidden = !v.onSale; }
      if (priceSave) {
        priceSave.textContent = (S.save || 'Ahorra') + ' −' + v.pct + '%';
        priceSave.hidden = !v.onSale;
      }
      if (atcBtn) atcBtn.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? (S.atc || 'Añadir al carrito') : (S.soldOut || 'Agotado');
      if (atcPrice) atcPrice.textContent = v.available ? '· ' + v.price : '';
      if (stockText) stockText.textContent = v.available ? (S.stockIn || 'En stock') : (S.stockOut || 'Sin stock');
      if (stockWrap) stockWrap.classList.toggle('is-out', !v.available);

      if (hayGrupos) {
        var color = opts[posColor - 1] || '';
        if (v.mediaId) alFrente(v.mediaId);
        var primero = filtrarPorColor(color);
        var delVariante = slidePorMedia(v.mediaId);
        if (delVariante && delVariante.hidden) delVariante = null;
        activar(delVariante || primero);
      } else {
        activar(slidePorMedia(v.mediaId));
      }

      if (hayOpciones) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    root.querySelectorAll('[data-mlb-option]').forEach(function (input) {
      input.addEventListener('change', update);
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activar(slidePorMedia(thumb.dataset.mediaId));
      });
    });

    root.querySelectorAll('[data-mlb-pop]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = root.querySelector('[data-mlb-popbox="' + btn.dataset.mlbPop + '"]');
        if (box) box.hidden = false;
      });
    });
    root.querySelectorAll('[data-mlb-popclose]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = btn.closest('[data-mlb-popbox]');
        if (box) box.hidden = true;
      });
    });

    /* ---------------------------------------------------------------
       Carrito: engancharse al del tema.
       Sin esto el formulario hace un POST normal y manda a la clienta
       a la pagina /cart, saliendose de la ficha. El tema esta en modo
       "cajon lateral" (theme.settings.cartType == 'drawer'), asi que
       le pasamos el formulario a theme.AjaxProduct(form, boton) y el
       tema se encarga: anade por ajax y abre su cajon.
       Si el tema no expusiera AjaxProduct, el formulario sigue
       funcionando como antes (POST a /cart/add): nunca deja de vender.
    --------------------------------------------------------------- */
    var formulario = root.querySelector('[data-mlb-form]');
    var enganchado = false;
    function engancharCarrito() {
      if (enganchado || !formulario) return true;
      if (!window.theme || typeof theme.AjaxProduct !== 'function') return false;
      try {
        new theme.AjaxProduct(formulario, '.mlb-atc');
        enganchado = true;
        formulario.dataset.mlbAjax = '1';
      } catch (e) { return false; }
      return true;
    }
    if (!engancharCarrito()) {
      window.addEventListener('load', engancharCarrito);
      var intentos = 0;
      var reloj = setInterval(function () {
        intentos++;
        if (engancharCarrito() || intentos > 20) clearInterval(reloj);
      }, 250);
    }

    root.dataset.mlbReady = '1';
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mlb]').forEach(init);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-mlb-popbox]').forEach(function (box) { box.hidden = true; });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
